export default "__VITE_ASSET__QR00RdXG__"